import { useAuthStore } from "@/store/auth";
import { useNavigate } from "react-router-dom";
import { BgTasksView } from "../components/BgTasksView";

export function BgTasksPage() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();

  if (!user?.is_developer && user?.role !== "director") {
    navigate("/", { replace: true });
    return null;
  }

  return <BgTasksView title="Zadania automatyczne" showUserFilter />;
}
